/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface OrderCalculated
 */
export interface OrderCalculatedOptional {
  /**
   * Total cost of service charges (Payment fees paid by customer, maybe we will add restock service fee?)
   * @type {number}
   * @memberof OrderCalculated
   */
  amountServiceChangeCents?: number;
  /**
   * Total of all capturable payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountCapturableCents?: number;
  /**
   * Total of all capturable and paid payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountAppliedCents?: number;
  /**
   * Total of all pending payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountPendingCents?: number;
  /**
   * Total of all refunded payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountRefundedCents?: number;
  /**
   * Total of all refunded items
   * @type {number}
   * @memberof OrderCalculated
   */
  amountToRefundCents?: number;
  /**
   * Total of all non-refunded items
   * @type {number}
   * @memberof OrderCalculated
   */
  amountToPayCents?: number;
}

export interface OrderCalculated extends OrderCalculatedOptional {
  /**
   * Total cost of service charges (Payment fees paid by customer, maybe we will add restock service fee?)
   * @type {number}
   * @memberof OrderCalculated
   */
  amountServiceChangeCents?: number;
  /**
   * Total of all capturable payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountCapturableCents?: number;
  /**
   * Total of all capturable and paid payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountAppliedCents?: number;
  /**
   * Total of all pending payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountPendingCents?: number;
  /**
   * Total of all refunded payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountRefundedCents?: number;
  /**
   * Total of all refunded items
   * @type {number}
   * @memberof OrderCalculated
   */
  amountToRefundCents?: number;
  /**
   * Total of all non-refunded items
   * @type {number}
   * @memberof OrderCalculated
   */
  amountToPayCents?: number;
}

export interface OrderCalculatedTrackedI {
  /**
   * Total cost of service charges (Payment fees paid by customer, maybe we will add restock service fee?)
   * @type {number}
   * @memberof OrderCalculated
   */
  amountServiceChangeCents?: number;
  amountServiceChangeCentsIsSet: boolean;
  /**
   * Total of all capturable payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountCapturableCents?: number;
  amountCapturableCentsIsSet: boolean;
  /**
   * Total of all capturable and paid payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountAppliedCents?: number;
  amountAppliedCentsIsSet: boolean;
  /**
   * Total of all pending payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountPendingCents?: number;
  amountPendingCentsIsSet: boolean;
  /**
   * Total of all refunded payments
   * @type {number}
   * @memberof OrderCalculated
   */
  amountRefundedCents?: number;
  amountRefundedCentsIsSet: boolean;
  /**
   * Total of all refunded items
   * @type {number}
   * @memberof OrderCalculated
   */
  amountToRefundCents?: number;
  amountToRefundCentsIsSet: boolean;
  /**
   * Total of all non-refunded items
   * @type {number}
   * @memberof OrderCalculated
   */
  amountToPayCents?: number;
  amountToPayCentsIsSet: boolean;
}

transformDatesMap.set("OrderCalculated", function (model: OrderCalculated) {});

export type OrderCalculatedMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  amountServiceChangeCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountCapturableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountAppliedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPendingCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToPayCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var OrderCalculatedMeta: OrderCalculatedMetaI =
  {} as OrderCalculatedMetaI;
OrderCalculatedMeta = typeMeta("OrderCalculated", {
  amountServiceChangeCents: propertyMeta(
    "amountServiceChangeCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountCapturableCents: propertyMeta(
    "amountCapturableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountAppliedCents: propertyMeta(
    "amountAppliedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPendingCents: propertyMeta(
    "amountPendingCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountRefundedCents: propertyMeta(
    "amountRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToRefundCents: propertyMeta(
    "amountToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToPayCents: propertyMeta(
    "amountToPayCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = OrderCalculatedMeta;

registerMeta(() => {});

export class OrderCalculatedTracked implements OrderCalculatedTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  amountServiceChangeCents__I?: number = undefined;
  amountServiceChangeCentsIsSet: boolean = false;
  set amountServiceChangeCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountServiceChangeCents__I = v;
      this.amountServiceChangeCentsIsSet = true;
    } else {
      this.amountServiceChangeCents__I = v || undefined;
      this.amountServiceChangeCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountServiceChangeCents() {
    return this.amountServiceChangeCents__I;
  }
  amountCapturableCents__I?: number = undefined;
  amountCapturableCentsIsSet: boolean = false;
  set amountCapturableCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCapturableCents__I = v;
      this.amountCapturableCentsIsSet = true;
    } else {
      this.amountCapturableCents__I = v || undefined;
      this.amountCapturableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCapturableCents() {
    return this.amountCapturableCents__I;
  }
  amountAppliedCents__I?: number = undefined;
  amountAppliedCentsIsSet: boolean = false;
  set amountAppliedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountAppliedCents__I = v;
      this.amountAppliedCentsIsSet = true;
    } else {
      this.amountAppliedCents__I = v || undefined;
      this.amountAppliedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountAppliedCents() {
    return this.amountAppliedCents__I;
  }
  amountPendingCents__I?: number = undefined;
  amountPendingCentsIsSet: boolean = false;
  set amountPendingCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPendingCents__I = v;
      this.amountPendingCentsIsSet = true;
    } else {
      this.amountPendingCents__I = v || undefined;
      this.amountPendingCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPendingCents() {
    return this.amountPendingCents__I;
  }
  amountRefundedCents__I?: number = undefined;
  amountRefundedCentsIsSet: boolean = false;
  set amountRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountRefundedCents__I = v;
      this.amountRefundedCentsIsSet = true;
    } else {
      this.amountRefundedCents__I = v || undefined;
      this.amountRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountRefundedCents() {
    return this.amountRefundedCents__I;
  }
  amountToRefundCents__I?: number = undefined;
  amountToRefundCentsIsSet: boolean = false;
  set amountToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundCents__I = v;
      this.amountToRefundCentsIsSet = true;
    } else {
      this.amountToRefundCents__I = v || undefined;
      this.amountToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundCents() {
    return this.amountToRefundCents__I;
  }
  amountToPayCents__I?: number = undefined;
  amountToPayCentsIsSet: boolean = false;
  set amountToPayCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToPayCents__I = v;
      this.amountToPayCentsIsSet = true;
    } else {
      this.amountToPayCents__I = v || undefined;
      this.amountToPayCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToPayCents() {
    return this.amountToPayCents__I;
  }
  constructor(config?: OrderCalculatedOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: OrderCalculatedOptional,
    options?: AssignOptions,
  ): OrderCalculatedTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.amountServiceChangeCents &&
      this.amountServiceChangeCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountServiceChangeCents = config.amountServiceChangeCents;
      if (optionsRequired.unassign) this.amountServiceChangeCentsIsSet = false;
      else this.amountServiceChangeCentsIsSet = true;
    }
    if (
      config.amountCapturableCents &&
      this.amountCapturableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCapturableCents = config.amountCapturableCents;
      if (optionsRequired.unassign) this.amountCapturableCentsIsSet = false;
      else this.amountCapturableCentsIsSet = true;
    }
    if (
      config.amountAppliedCents &&
      this.amountAppliedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountAppliedCents = config.amountAppliedCents;
      if (optionsRequired.unassign) this.amountAppliedCentsIsSet = false;
      else this.amountAppliedCentsIsSet = true;
    }
    if (
      config.amountPendingCents &&
      this.amountPendingCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPendingCents = config.amountPendingCents;
      if (optionsRequired.unassign) this.amountPendingCentsIsSet = false;
      else this.amountPendingCentsIsSet = true;
    }
    if (
      config.amountRefundedCents &&
      this.amountRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountRefundedCents = config.amountRefundedCents;
      if (optionsRequired.unassign) this.amountRefundedCentsIsSet = false;
      else this.amountRefundedCentsIsSet = true;
    }
    if (
      config.amountToRefundCents &&
      this.amountToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundCents = config.amountToRefundCents;
      if (optionsRequired.unassign) this.amountToRefundCentsIsSet = false;
      else this.amountToRefundCentsIsSet = true;
    }
    if (
      config.amountToPayCents &&
      this.amountToPayCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToPayCents = config.amountToPayCents;
      if (optionsRequired.unassign) this.amountToPayCentsIsSet = false;
      else this.amountToPayCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderCalculatedTrackedI {
    const cloned = {} as OrderCalculatedTrackedI;
    if (
      this.amountServiceChangeCentsIsSetDeep() &&
      this.amountServiceChangeCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountServiceChangeCentsIsSet = true;
      cloned.amountServiceChangeCents = this.amountServiceChangeCents;
    } else {
      //cloned.amountServiceChangeCentsIsSet = false
    }
    if (
      this.amountCapturableCentsIsSetDeep() &&
      this.amountCapturableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCapturableCentsIsSet = true;
      cloned.amountCapturableCents = this.amountCapturableCents;
    } else {
      //cloned.amountCapturableCentsIsSet = false
    }
    if (
      this.amountAppliedCentsIsSetDeep() &&
      this.amountAppliedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountAppliedCentsIsSet = true;
      cloned.amountAppliedCents = this.amountAppliedCents;
    } else {
      //cloned.amountAppliedCentsIsSet = false
    }
    if (
      this.amountPendingCentsIsSetDeep() &&
      this.amountPendingCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPendingCentsIsSet = true;
      cloned.amountPendingCents = this.amountPendingCents;
    } else {
      //cloned.amountPendingCentsIsSet = false
    }
    if (
      this.amountRefundedCentsIsSetDeep() &&
      this.amountRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountRefundedCentsIsSet = true;
      cloned.amountRefundedCents = this.amountRefundedCents;
    } else {
      //cloned.amountRefundedCentsIsSet = false
    }
    if (
      this.amountToRefundCentsIsSetDeep() &&
      this.amountToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundCentsIsSet = true;
      cloned.amountToRefundCents = this.amountToRefundCents;
    } else {
      //cloned.amountToRefundCentsIsSet = false
    }
    if (
      this.amountToPayCentsIsSetDeep() &&
      this.amountToPayCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToPayCentsIsSet = true;
      cloned.amountToPayCents = this.amountToPayCents;
    } else {
      //cloned.amountToPayCentsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderCalculatedTrackedI {
    if (!this.amountServiceChangeCentsApplyFilter(filter))
      this.amountServiceChangeCentsIsSet = false;

    if (!this.amountCapturableCentsApplyFilter(filter))
      this.amountCapturableCentsIsSet = false;

    if (!this.amountAppliedCentsApplyFilter(filter))
      this.amountAppliedCentsIsSet = false;

    if (!this.amountPendingCentsApplyFilter(filter))
      this.amountPendingCentsIsSet = false;

    if (!this.amountRefundedCentsApplyFilter(filter))
      this.amountRefundedCentsIsSet = false;

    if (!this.amountToRefundCentsApplyFilter(filter))
      this.amountToRefundCentsIsSet = false;

    if (!this.amountToPayCentsApplyFilter(filter))
      this.amountToPayCentsIsSet = false;

    return this;
  }
  amountServiceChangeCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderCalculatedMeta.amountServiceChangeCents,
      OrderCalculatedMeta,
      this.amountServiceChangeCents,
      this,
    );
  }
  amountServiceChangeCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountServiceChangeCentsIsSet &&
      this.amountServiceChangeCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountCapturableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderCalculatedMeta.amountCapturableCents,
      OrderCalculatedMeta,
      this.amountCapturableCents,
      this,
    );
  }
  amountCapturableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountCapturableCentsIsSet &&
      this.amountCapturableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountAppliedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderCalculatedMeta.amountAppliedCents,
      OrderCalculatedMeta,
      this.amountAppliedCents,
      this,
    );
  }
  amountAppliedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountAppliedCentsIsSet &&
      this.amountAppliedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountPendingCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderCalculatedMeta.amountPendingCents,
      OrderCalculatedMeta,
      this.amountPendingCents,
      this,
    );
  }
  amountPendingCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountPendingCentsIsSet &&
      this.amountPendingCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderCalculatedMeta.amountRefundedCents,
      OrderCalculatedMeta,
      this.amountRefundedCents,
      this,
    );
  }
  amountRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountRefundedCentsIsSet &&
      this.amountRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderCalculatedMeta.amountToRefundCents,
      OrderCalculatedMeta,
      this.amountToRefundCents,
      this,
    );
  }
  amountToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundCentsIsSet &&
      this.amountToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToPayCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderCalculatedMeta.amountToPayCents,
      OrderCalculatedMeta,
      this.amountToPayCents,
      this,
    );
  }
  amountToPayCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountToPayCentsIsSet && this.amountToPayCentsApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.amountServiceChangeCentsIsSetDeep(filter)) return true;
    if (this.amountCapturableCentsIsSetDeep(filter)) return true;
    if (this.amountAppliedCentsIsSetDeep(filter)) return true;
    if (this.amountPendingCentsIsSetDeep(filter)) return true;
    if (this.amountRefundedCentsIsSetDeep(filter)) return true;
    if (this.amountToRefundCentsIsSetDeep(filter)) return true;
    if (this.amountToPayCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
